import { useEffect } from 'react'
import {
  TextField,
  DateField,
  useRefresh,
  useDataProvider,
  List,
  Datagrid,
  NumberField,
  ResourceContextProvider,
  useRecordContext,
} from 'react-admin'
import {
  Dialog,
  DialogTitle,
  DialogActions,
  DialogContentText,
  DialogContent,
  Button,
} from '@material-ui/core'
import CheckIcon from '@mui/icons-material/Check'
import { InvoiceLinks } from '../utils'

const ApproveCoproprietaireButton = ({ disabled }) => {
  const refresh = useRefresh()
  const dataProvider = useDataProvider()
  const record = useRecordContext()
  if (!record || record.approved_cs_coproprietaire_id !== null)
    return <CheckIcon />

  const func = () => {
    dataProvider
      .update('ext_copro_invoices', {
        id: record.id,
        data: { ...record, path: 'approve_cs' },
      })
      .then((response) => {
        refresh()
      })
      .catch((error) => {
        alert(`${error.message}`, 'warning')
      })
  }
  return (
    <Button
      variant="contained"
      color="primary"
      label="Approbation CS"
      onClick={func}
      size="small"
      disableElevation
    >
      Approbation CS
    </Button>
  )
}

const Empty = () => {
  return (
    <div>
      <DialogContentText>Vous retrouverez ici les factures.</DialogContentText>
    </div>
  )
}

export const ExtCoproInvoiceListDialog = (props) => {
  const copro_id = props.copro_id
  const coproprietaire_id = props.coproprietaire_id

  const setWindowContext = () => {
    window.context['context-extcoproticket-coproid'] = copro_id
    window.context['context-extcoproticket-coproprietaireid'] =
      coproprietaire_id
  }
  useEffect(() => {
    setWindowContext()
  }, [copro_id, coproprietaire_id])
  setWindowContext()

  return (
    <Dialog
      open={props.show}
      onClose={props.handleClose}
      maxWidth="lg"
      fullWidth={true}
    >
      <DialogTitle>Suivi des factures</DialogTitle>
      <DialogContent>
        <ResourceContextProvider value="ext_copro_invoices">
          <List
            component="div"
            actions={''}
            sort={false}
            pagination={false}
            syncWithLocation
            basePath="/ext_copro_invoices"
            exporter={false}
            empty={<Empty />}
          >
            <Datagrid rowClick={false} bulkActionButtons={false}>
              <NumberField source="id" label="Id" />
              <NumberField source="ticket_id" label="Ticket" />
              <TextField source="code" label="Copro" />
              <TextField source="libelle" label="Libelle" />
              <NumberField source="montant_ht" label="HT" />
              <NumberField source="montant_ttc" label="TTC" />
              <InvoiceLinks source="facture" label="Facture" />
              <DateField source="created" label="Créé le" />
              <ApproveCoproprietaireButton label="Approb. CS" />
            </Datagrid>
          </List>
        </ResourceContextProvider>
      </DialogContent>
      <DialogActions>
        <Button
          variant="contained"
          color="secondary"
          onClick={props.handleClose}
          disableElevation
        >
          Fermer
        </Button>
      </DialogActions>
    </Dialog>
  )
}
